import axios from 'axios'

export default {
    data: function () {
        return {
            enabledFeatures: [],
            enabledPermissions: [],
        }
    },
    beforeMount() {
        if (typeof dataObject !== 'undefined') {
            this.enabledFeatures = dataObject.enabledFeatures;
            this.enabledPermissions = dataObject.enabledPermissions;
            delete dataObject.enabledFeatures;
            delete dataObject.enabledPermissions;
        }
    },
    methods: {
        isFeatureAllowed(str) {
            if(this.enabledFeatures === null || this.enabledFeatures === undefined || this.enabledFeatures.length == 0) {
                return;
            }
            return this.enabledFeatures.includes(str);
        },
        isPermissionAllowed(str) {
            if(this.enabledPermissions === null || this.enabledPermissions === undefined || this.enabledPermissions.length == 0) {
                return;
            }
            return this.enabledPermissions.includes(str);
        },
    }
}